import Config from 'src/config';
import { ChatSession } from 'src/interfaces/Chat';
import { api, Api } from '../MainService/api';
import { ErrorKind } from '../MainService/apiProblem';
import { MessageList } from './chat.api.types';

const CHAT_URL = Config.CHAT_URL;

export class ChatApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async getAllSessions(queryString: string) {
    try {
      const response = await this.api.apisauce.get<{
        chat_sessions: ChatSession[];
      }>(`${CHAT_URL}/get-all-chat-session?${queryString}`);
      let data = await this.api.getResponse(response);

      return data;
    } catch (e) {
      console.error('Error fetching chat sessions:', e);
      return {
        kind: ErrorKind.BAD_DATA_ERROR,
        errors: 'Failed to fetch chat sessions',
      };
    }
  }

  async createNewSession(
    session_title: string,
    subject_id: string,
    level_id?: string
  ) {
    try {
      let url = `${CHAT_URL}/create-chat-session?session_title=${encodeURIComponent(
        session_title
      )}&subject=${encodeURIComponent(subject_id)}`;

      // Add level_id to the URL if provided
      if (level_id) {
        url += `&level_id=${encodeURIComponent(level_id)}`;
      }

      const response = await this.api.apisauce.post<ChatSession>(url);
      let data = await this.api.getResponse(response);

      return data;
    } catch (e) {
      console.error('Error creating chat session:', e);
      return {
        kind: ErrorKind.BAD_DATA_ERROR,
        errors: 'Failed to create chat session',
      };
    }
  }

  async updateSessionTitle(session_title: string, session_id: string) {
    try {
      const response = await this.api.apisauce.post(
        `${CHAT_URL}/modify-chat-session-title?chat_session_id=${session_id}&new_session_title=${session_title}`
      );
      let data = await this.api.getResponse(response);

      return data;
    } catch (e) {
      // alert("You entered some bad data")
      return { kind: ErrorKind.BAD_DATA_ERROR, errors: 'Bad Data' };
    }
  }

  async deleteSession(session_id: string) {
    try {
      const response = await this.api.apisauce.delete(
        `${CHAT_URL}/delete-chat-session?chat_session_id=${session_id}`
      );
      console.log('response from delete', response);
      let data = await this.api.getResponse(response);

      return data;
    } catch (e) {
      // alert("You entered some bad data")
      return { kind: ErrorKind.BAD_DATA_ERROR, errors: 'Bad Data' };
    }
  }

  async getAllMessages(sessionId: string) {
    try {
      const response = await this.api.apisauce.get<MessageList>(
        `${CHAT_URL}/get-chat-session-msgs?chat_session_id=${sessionId}`
      );
      let data = await this.api.getResponse(response);

      return data;
    } catch (e) {
      // alert("You entered some bad data")
      return { kind: ErrorKind.BAD_DATA_ERROR, errors: 'Bad Data' };
    }
  }

  async sendMessage(
    user_msg: string,
    read_url: string | undefined,
    session_id: string,
    level?: string,
    subject?: string,
    level_id?: string
  ) {
    try {
      // let parsedToken;
      // const token = await getToken();

      // if (token) {
      //   const todaysDate = new Date();
      //   const tokenExpiry = new Date(token?.expires_at);

      //   if (!(tokenExpiry.getTime() > todaysDate.getTime())) {
      //     const refresh = await authService.getRefreshToken(token.refresh_token);
      //     if (refresh.kind == ResponseKind.OK && refresh?.data) {
      //       const refresh_token = refresh.data;
      //       setToken(refresh_token)
      //       parsedToken = refresh_token?.access_token;
      //     }
      //   } else {
      //     parsedToken = token.access_token;
      //   }
      // }

      // if (!parsedToken) {
      //   throw new Error("No access token available");
      // }
      const requestBody: any = {
        user_msg: user_msg,
        image_url: read_url ? [read_url] : undefined,
        session_id: session_id,
      };

      if (level) {
        requestBody.level = level;
      }
      if (subject) {
        requestBody.subject = subject;
      }
      if (level_id) {
        requestBody.level_id = level_id;
      }

      console.log(
        'Sending chat message with data:',
        JSON.stringify(requestBody, null, 2)
      );

      const response = await this.api.apisauce.post<{ ai_response: string }>(
        `${CHAT_URL}/send-msg`,
        requestBody
      );
      let data = await this.api.getResponse(response);
      console.log('send message repsonse ', response);
      // const response: any = await fetch(`${CHAT_URL}/send-msg`, {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //     Authorization: `Bearer ${parsedToken}`,
      //   },
      //   body: JSON.stringify({
      //     user_msg: user_msg,
      //     // traceless: traceless,
      //     // mode: mode,
      //   }),
      // });
      // debugger
      // const reader = response.body.getReader();

      return data;
    } catch (e) {
      // alert("Your link is bad")
      return { kind: ErrorKind.BAD_DATA_ERROR, errors: 'Bad Data' };
    }
  }

  async getSuggestedQuestion(check: boolean, session_id: string) {
    try {
      const response = await this.api.apisauce.post<{ ai_response: string }>(
        `${CHAT_URL}/update-user-question-mode/${check}?chat_session_id=${session_id}`
      );
      console.log('Response from new api ', response);
      let data = await this.api.getResponse(response, true);
      return data;
    } catch (e) {
      console.log(e);
      return { kind: ErrorKind.BAD_DATA_ERROR };
    }
  }

  async clearChat() {
    try {
      const response = await this.api.apisauce.delete(`${CHAT_URL}/clear-chat`);
      let data = await this.api.getResponse(response, true);
      return data;
    } catch (e) {
      console.log(e);
      return { kind: ErrorKind.BAD_DATA_ERROR };
    }
  }

  async fetchChildSessionQuestion(
    session_id: string,
    level: string,
    subject: string
  ) {
    try {
      const response = await this.api.apisauce.post<{ ai_response: string }>(
        `${CHAT_URL}/fetch-question`,
        { session_id, level, subject }
      );

      const result = await this.api.getResponse(response, true);
      console.log('Result from fetchChildSessionQuestion', result);
      if (result.kind !== 'ok' || !result.data) {
        return { kind: ErrorKind.BAD_DATA_ERROR };
      }

      const ai_response = result.data.ai_response;

      if (!ai_response) {
        return {
          text: 'Unexpected response format.',
          image_url: null,
          hasQuestion: false,
        };
      }

      try {
        const parsed = JSON.parse(ai_response);
        return {
          text: parsed.text || '',
          image_url: parsed.image_url || null,
          hasQuestion: true,
        };
      } catch {
        return {
          text: ai_response,
          image_url: null,
          hasQuestion: false,
        };
      }
    } catch (e) {
      console.log(e);
      return { kind: ErrorKind.BAD_DATA_ERROR };
    }
  }
}

export const chatService = new ChatApi(api);
